export default "__VITE_ASSET__CnIZAFSp__"